import { Injectable, inject } from '@angular/core';

import { EventParticipant } from '@frontend/sports/betting-offer/feature/model';
import { ParticipantsConfig } from '@frontend/sports/common/client-config-data-access';

@Injectable({ providedIn: 'root' })
export class ShortTeamNamesService {
    private participantsConfig = inject(ParticipantsConfig);

    shouldUseShortName(
        participant: EventParticipant,
        sportId: number,
        leagueId: number,
        shortNameModule: string,
        ignoreShortNamesDynacon?: boolean,
    ): boolean {
        if (!participant.shortName) {
            return false;
        }

        if (ignoreShortNamesDynacon) {
            return true;
        }

        const enabledSportLeagues = this.getEnabledSportLeagues(sportId);

        if (!enabledSportLeagues) {
            return false;
        }

        return this.isEnabledShortName(enabledSportLeagues, leagueId, shortNameModule);
    }

    private getEnabledSportLeagues(sportId: number): Record<string, string[] | undefined> | undefined {
        const enabledShortNames = this.participantsConfig?.enabledShortNames || {};

        return enabledShortNames[sportId] ?? enabledShortNames['0'];
    }

    private isEnabledShortName(sportLeagues: Record<string, string[] | undefined>, leagueId: number, shortNameModule: string): boolean {
        const areaName = sportLeagues[leagueId] || sportLeagues['0'];

        return areaName?.includes(shortNameModule) || false;
    }

    clearShortName(name: string): string {
        return name
            .replace(/\\*\([^)]*\)\\*/g, '')
            .trim()
            .replace(/ \//g, '/');
    }
}

export enum ShortNameModule {
    Grids = 'Grids',
    EdpScoreboard = 'EDPScoreboard',
    LeftHandNav = 'LeftHandNav',
    Marquee = 'Marquee',
    GameLines = 'GameLines',
    Spread = 'Spread',
    PopularBets = 'PopularBets',
}
